
(function () {
    if (window.giftCardPopupInitialized) return;
    window.giftCardPopupInitialized = true;

    console.log('Gift Card Popup Script Loaded');

    document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-samitapbl-handle]');

        if (!trigger) return;

        e.preventDefault();
        const handle = trigger.getAttribute('data-samitapbl-handle');

        if (!handle) return;

        let modal = document.getElementById('gift-card-quick-buy-modal');

        if (!modal) {
            modal = document.createElement('quick-buy-modal');
            modal.id = 'gift-card-quick-buy-modal';
            modal.classList.add('quick-buy-modal', 'modal', 'drawer', 'drawer--end');
            modal.classList.add('quick-buy-modal--gift-card');
            document.body.appendChild(modal);
        }

        modal.setAttribute('handle', handle);
        modal.show();
    });
})();
